import React from "react";

function UseTermsPage() {
  return (
    <article className="max-w-[60vw] text-center mx-auto my-20">
      <h1 className="font-bold text-4xl mb-4">TÉRMINOS Y CONDICIONES</h1>
      <h2 className="font-bold text-2xl mb-4">DESCRIPCIÓN DEL SERVICIO</h2>
      <p className="text-xl text-justify">
        El Ministerio de Medio Ambiente y Recursos Naturales entidad encargada
        de la administración del Sistema Nacional de Áreas Protegidas vende a
        través del Sitio Web Ventanilla Única de Servicios Ambientales{" "}
        <span className="font-bold">(VUSA) &nbsp;</span>
        los tickets de acceso a las áreas protegidas que conforman el Sistema
        Nacional de Áreas Protegidas de la República Dominicana. El usuario
        ingresará bajo su propia responsabilidad. Por su seguridad evite riesgos
        y disfrute su estadía.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">USUARIOS</h2>
      <p className="text-xl text-justify">
        El acceso y uso de VUSA atribuye la condición de USUARIO, que acepta,
        desde dicho acceso y uso los Términos y Condiciones aquí reflejadas.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">COMPRA TICKETS DE ACCESO </h2>
      <p className="text-xl text-justify">
        La compra de los tickets de acceso a las áreas protegidas del Sistema
        Nacional de Áreas Protegidas podrá ser realizada mediante el uso de
        tarjetas de crédito y/o débito. Para poder adquirir los tickets de
        acceso el usuario deberá crear una cuenta de usuario debiendo acceder y
        completar los datos de registro el cual se accede a través del enlace
        denominado “comprar tickets” ubicado en este sitio web. <br />
        El usuario acepta que ha proporcionado datos personales verdaderos y
        asume total responsabilidad de la información falsa o fraudulenta
        ingresada bajo su cuenta de usuario. Quien suministre datos falsos o
        fraudulentos será responsable personalmente en los términos de las leyes
        vigentes dominicana.
        <br /> Las compras realizadas a través de VUSA están sujetas a
        validación de datos por parte de la entidad emisora de la tarjeta
        correspondiente y del sistema transaccional de pagos electrónicos.
        <br />
        Antes de completar su compra, el usuario debe revisar cuidadosamente la
        cantidad y tipo de tickets de acceso que va a adquirir, considerando que
        una vez confirmada su compra no se podrán hacer cambios o modificaciones
        en la cantidad y tipo de tickets de acceso.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">MENORES DE EDAD</h2>
      <p className="text-xl text-justify">
        Ventanilla Única de Servicios Ambientales{" "}
        <span className="font-bold">(VUSA) &nbsp;</span> dirige sus servicios a
        mayores de 18 años conforme lo dispuesto por el{" "}
        <span className="font-bold">artículo 4888</span> del Código Civil de la
        República Dominicana. Los menores de no están autorizados a utilizar los
        servicios de VUSA y suministrar sus datos personales, sino a través de
        sus padres o tutores legales. En consecuencia, el Ministerio de Medio
        Ambiente y Recursos Naturales no se hace responsable de posibles
        consecuencias ni daños a terceros que pudieran derivarse del
        incumplimiento del aviso que se establecen en estos Términos y
        Condiciones.
      </p>
      <br />
      <h2 className="font-bold text-2xl mb-4">VIGENCIA DE LOS TICKETS</h2>
      <p className="text-xl text-justify">
        Los tickets de acceso que sean comprados a través de VUSA tendrán una
        duración de <span className="font-bold">vigencia de 15 días</span>{" "}
        después de la fecha seleccionada de la visita al área protegida. Una vez
        vencido este plazo el usuario no podrá requerir devolución de los montos
        pagados por concepto de compra, ni extender la vigencia a un plazo
        adicional al pautado en los presentes términos y condiciones.
      </p>

      <br />
      <h2 className="font-bold text-2xl mb-4">CAMBIOS Y DEVOLUCIONES</h2>
      <p className="text-xl text-justify">
        Salvo a través de la emisión de un acto administrativo por parte del
        Ministerio de Medio Ambiente y Recursos Naturales que así lo disponga.
        No se permiten cambios, reintegros o devoluciones de los tickets de
        acceso a áreas protegidas adquiridos por el Sitio Web VUSA. Tampoco se
        realizarán reposición de tickets de acceso extraviados, dañados o
        robados.
      </p>

      <br />
      <h2 className="font-bold text-2xl mb-4">
        PROHIBICIÓN DE ACAPARAMIENTO Y PRACTICAS ESPECULATIVAS
      </h2>
      <p className="text-xl text-justify">
        Se prohíbe el acaparamiento y prácticas especulativas o comerciales con
        la adquisición de tickets de acceso de áreas protegidas vendidas a
        través del Sitio Web VUSA.
      </p>

      <br />
      <h2 className="font-bold text-2xl mb-4">
        MODIFICACIÓN DE TÉRMINOS Y CONDICIONES
      </h2>
      <p className="text-xl text-justify">
        El Ministerio de Medio Ambiente y Recursos Naturales podrá modificar los
        presentes Términos y Condiciones, haciéndolo público en este Sitio Web.
      </p>

      <br />
      <h2 className="font-bold text-2xl mb-4">PROTECCIÓN DE DATOS</h2>
      <p className="text-xl text-justify">
        La base de datos de este Sitio Web es administrada bajo principios de
        seguridad, protección y confidencialidad de datos personales de
        conformidad con las disposiciones de la Ley de Protección de Datos
        Personales <span className="font-bold">No. 172-13.</span> El usuario
        reconoce y acepta que la información suministrada será utilizada para
        mejorar los servicios del Sitio Web y que en ningún caso será divulgada
        o relevada a terceros.
      </p>
    </article>
  );
}

export default UseTermsPage;
